import { OptionItemObject } from '../../shared_models/interfaces';

import csvValidator from './validation/CsvValidator';
import jsonValidator from './validation/JsonValidator';
import { csvToJson, mapToImportExportLevel } from './csvToJsonParser';
import { ImportExportJson } from './public_model';

export enum FILE_TYPE {
    CSV = 'csv',
    JSON = 'json',
}

export const validateInput = (fileType: FILE_TYPE, input: string, treeData: OptionItemObject[]) => {
    if (fileType === FILE_TYPE.CSV) {
        const csvAsJson = csvToJson(input);
        const validationResult = csvValidator.validate(csvAsJson, treeData);
        return {
            ...validationResult,
            data: validationResult.success ? mapToImportExportLevel(csvAsJson.options) : undefined,
        };
    } else {
        const validationResult = jsonValidator.validate(input, treeData);
        return {
            ...validationResult,
            data: validationResult.success ? (JSON.parse(input) as ImportExportJson).firstLevel : undefined,
        };
    }
};
